"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeselectedSeriesSelector = void 0;
var getDeselectedSeriesSelector = function (state) { return state.interactions.deselectedDataSeries; };
exports.getDeselectedSeriesSelector = getDeselectedSeriesSelector;
//# sourceMappingURL=get_deselected_data_series.js.map